const state = {
  user_promo: [],
  user_promo_id: [],
  dimension: [],
  Adminhub: [],
  dicountType: [],
  Addon: [],
  newuser_availability: [],
  ExtraPackaging: [],
};

export default state;
